<template>
    <div>
      <Head :title="__(title)" />
      
      <div class="flex flex-col md:flex-row gap-3 mb-4 justify-between items-center ticket-filters">
            <search-input v-model="form.search" placeholder="Buscar" class="w-full max-w-md search" @reset="reset"></search-input>
            <div class="filter-add-new flex flex-col gap-3 md:flex-row items-center">
                <a class="btn-indigo" :href="exportUrl">
                    <span>{{ __('Descargar Excel') }}</span>
                </a>
                <Link class="btn-indigo" :href="this.route('location.create')">
                    <span>{{ __('Create New') }}</span>
                </Link>
            </div>
        </div>


      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4"></th>
            <th class="px-6 pt-6 pb-4">{{ __('ID') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Nombre del lugar') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Tipo de Lugar') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Ubicación Física') }}</th> 
            <th class="px-6 pt-6 pb-4">{{ __('Capacidad') }}</th> 
            <th class="px-6 pt-6 pb-4">{{ __('Estado') }}</th> 
          </tr>
          <tr v-for="type in equipaments.data" :key="type.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t w-px">
              <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('qr.generate', type.qr)"  target="_blank">
                <img src="/images/qr_img.png" style="height: 50px; min-width: 50px; !important; width: 50px !important;">
              </Link>
            </td>
            <td class="border-t w-px">
              <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('location.edit', type.id)">
                {{ type.id }}
              </Link>
            </td>
            <td class="border-t w-px">
              <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('location.edit', type.id)">
                {{ type.name }}
              </Link>
            </td>
            <td class="border-t w-px">
              <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('location.edit', type.id)">
                {{ type.type }}
              </Link>
            </td>
            <td class="border-t w-px">
              <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('location.edit', type.id)">
                {{ type.location_name }}
              </Link>
            </td>
            <td class="border-t w-px">
              <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('location.edit', type.id)">
                {{ type.ability }}
              </Link>
            </td>
            <td class="border-t w-px">
              <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('location.edit', type.id)">
                {{ type.status }}
              </Link>
            </td>
          </tr>
          <tr v-if="equipaments.data.length === 0">
            <td class="border-t px-6 py-4" colspan="4">{{ __('No types found') }}.</td>
          </tr>
        </table>
      </div>
      <pagination class="mt-6" :links="equipaments.links" />
    </div>
  </template>
  
  <script>
  import { Link, Head } from '@inertiajs/inertia-vue3'
  import Icon from '@/Shared/Icon'
  import pickBy from 'lodash/pickBy' 
  import Layout from '@/Shared/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import Pagination from '@/Shared/Pagination'
  import SearchInput from '@/Shared/SearchInput'
  import ImageSvg from '@/Shared/ImageSvg'

  export default {
    metaInfo: { title: 'Types' },
    components: {
        SearchInput,
      Icon,
      Link,
      Head,
      Pagination,
      ImageSvg
    },
    layout: Layout,
    props: {
      title: String,
      filters: Object,
      equipaments: Object,
    },
    data() {
      return {
        form: {
          search: this.filters.search,
        },
      }
    },
    computed: {
      exportUrl() {
        return this.route('location.export', pickBy({ search: this.form.search }))
      },
    },
    watch: {
      form: {
        deep: true,
        handler: throttle(function() {
          this.$inertia.get(this.route('location'), pickBy(this.form), { preserveState: true })
        }, 150),
      },
    },
    methods: {
      reset() {
        this.form = mapValues(this.form, () => null)
      },
      doFilter(e){
            this.axios.get(this.route('location.search', {search: e.target.value})).then((res)=>{
                this.equipaments.splice(0, this.equipaments.length, ...res.data);
            })
        },
    },
  }
  </script>
  